<template>
  <div>
    <div class="image-preview">
      <i v-show="!photo" class="fa fa-spinner fa-spin fa-6x fa-fw"></i>
      <span class="close" @click="deleteImage()"
        ><i class="fa fa-trash" title="Delete this photo"></i
      ></span>
      <img
        class="background-image img img-responsive"
        id="imgPrevBackground"
        v-show="photo"
        :src="photoComp"
      />
      <div v-if="uploading" class="progress progress-image">
        <div
          class="progress-bar progress-bar-success progress-bar-striped"
          role="progressbar"
          :style="{ width: uploadCompletePct }"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <span> {{ uploadStatusPct }}</span>
        </div>
      </div>
      <span class="my-button">
        <label class="btn btn-success btn-title">
          {{ UploadPhotoTxtComp }} <i class="fa fa-camera" /><input
            style="display: none"
            class="file"
            type="file"
            @change="previewThumbnail"
            accept="image/jpeg, image/bmp, image/png"
          />
        </label>
      </span>
    </div>

    <div class="container" id="crop-avatar">
      <!-- Button trigger modal -->

      <!-- Modal -->
      <div
        class="modal fade"
        id="modalBackground"
        role="dialog"
        aria-labelledby="modalLabel"
        tabindex="-1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="modal-title">
                <i class="fa fa-camera"></i> Add background photo
              </h2>
            </div>
            <div class="modal-body row">
              <div
                class="img-container col-md-6"
                style="max-width: 100%; max-height: 300px; overflow: hidden"
              >
                <img
                  id="cropMeBackground"
                  :src="uploadedImageSrc"
                  alt="Picture"
                  style="max-width: 100%; max-height: 100%; overflow: hidden"
                  crossorigin
                />
              </div>
              <div class="col-md-6 hidden-xs hidden-sm">
                <h4>How it will look on your profile</h4>
                <div class="docs-preview clearfix">
                  <div class="img-preview preview-md"></div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                @click="saveImage"
                class="btn btn-success btn-title"
                data-dismiss="modal"
              >
                Save Image
              </button>
              <button
                type="button"
                @click="cancelSave"
                class="btn btn-default btn-title"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loadImage from "blueimp-load-image";
import auth from "../../../auth";
import store from "../../../data/store";
import router from "../../../router";
var dataURLtoBlob = require("blueimp-canvas-to-blob");
export default {
  name: "UploadBackgroundPhoto",
  data() {
    return {
      filePath: "",
      cropOptions: {
        aspectRatio: 16 / 9,
        background: false,
        autoCropArea: 1.0,
        strict: true,
        guides: false,
        highlight: false,
        dragCrop: false,
        zoomable: true,
        checkCrossOrigin: true,
        cropBoxResizable: false,
        modal: true,
        preview: ".img-preview",
      },
      uploadCompletePct: "",
      uploading: false,
      photo: {
        Path: "",
        SitterPhotoId: 0,
      },
      uploadedImageSrc: "",
    };
  },
  methods: {
    previewThumbnail: function (event) {
      var orientationVal = true;
      var input = event.target;
      if (input.files && input.files[0]) {
        var self = this;
        self.uploadCompletePct = "";
        var file = input.files[0];

        loadImage.parseMetaData(file, function (data) {
          // Get the correct orientation setting from the EXIF Data
          if (data.exif) {
            orientationVal = data.exif.get("Orientation");
          } else orientationVal = true;
          var loadingImage = loadImage(file);

          loadingImage.onload = function (e) {
            var scaledImage = loadImage.scale(
              loadingImage, // img or canvas element
              { orientation: orientationVal }
            );

            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");

            var maxWidth = 1920,
              maxHeight = 1080,
              imageWidth = scaledImage.width,
              imageHeight = scaledImage.height;

            if (imageWidth > imageHeight) {
              if (imageWidth > maxWidth) {
                imageHeight *= maxWidth / imageWidth;
                imageWidth = maxWidth;
              }
            } else {
              if (imageHeight > maxHeight) {
                imageWidth *= maxHeight / imageHeight;
                imageHeight = maxHeight;
              }
            }
            canvas.width = imageWidth;
            canvas.height = imageHeight;

            ctx.drawImage(scaledImage, 0, 0, imageWidth, imageHeight);

            // The resized file ready for upload
            var finalFile = canvas.toDataURL("image/png");

            $("#modalBackground").modal("show");
            self.uploadedImageSrc = finalFile;
          };
        });
      }
    },
    saveImage: function () {
      var self = this;
      self.uploading = true;
      self.uploadCompletePct = "";

      var dataUrlImage = $("#cropMeBackground")
        .cropper("getCroppedCanvas")
        .toDataURL("image/jpeg");

      var blob = dataURLtoBlob(dataUrlImage);

      //   $('#cropMeBackground').cropper('getCroppedCanvas').toBlob(function (blob) {
      var formData = new FormData();

      formData.append("image", blob);

      $.ajax("https://www.dupaws.com/services/api/postSitterBackgroundPhoto", {
        type: "POST",
        xhr: function () {
          // custom xhr
          var xhr = new window.XMLHttpRequest();
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                self.uploadCompletePct =
                  Math.round(percentComplete * 100) + "%";
              }
            },
            false
          );
          return xhr;
        },
        data: formData,
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        crossDomain: true,
        processData: false,
        contentType: false,
        success: function (data) {
          self.photo = data;
          self.uploading = false;
          self.uploadedCompletePct = 0;
          self.$parent.$parent.updateProfileStatus();
        },
        error: function () {
          console.log("Upload error");
          self.uploadedCompletePct = 0;
          self.uploading = false;
        },
      });
      //        }, 'image/jpeg', 0.85);
    },
    cancelSave: function () {},
    deleteImage: function () {
      var self = this;
      if (!this.photo.SitterPhotoId) {
        console.log("No photo to delete");
        return;
      } else {
        swal("", "Please click on Change Background Image instead", "info");
      }
      //  $.ajax("https://www.dupaws.com/services/api/deleteSitterBackgroundPhoto/" + this.photoIdComp, { //no need to delete bg image from now on...
      //           type: 'POST',
      //           beforeSend: function(xhr){
      //               xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
      //           },
      //           dataType:"json",
      //           contentType: "application/json; charset=utf-8",
      //           crossDomain: true,
      //           success: function () {
      //             self.photo.SitterPhotoId = 0
      //             self.photo.Path = "/images/site/background.png"
      //             self.$parent.$parent.updateProfileStatus()

      //             },
      //           error: function () {
      //               console.log('Couldnt delete background image');
      //           }
      //       });
    },
  },
  created: function () {},
  mounted: function () {
    var self = this;
    if (!store.getters.authenticated && !localStorage.getItem("access_token")) {
      router.router.push({ path: "/login", query: { redirect: "home" } });
    }

    $.ajax("https://www.dupaws.com/services/api/getSitterBackgroundPhoto", {
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      crossDomain: true,
      success: function (data) {
        self.photo = data;
      },
      error: function () {
        console.log(
          'Couldnt get sitter background photo "api/getSitterBackgroundPhoto"'
        );
      },
    });

    $("#modalBackground")
      .on("shown.bs.modal", function () {
        $("#cropMeBackground").cropper(self.cropOptions);
      })
      .on("hidden.bs.modal", function () {
        $("#cropMeBackground").cropper("destroy");
      });
  },
  computed: {
    uploadStatusPct: function () {
      var self = this;
      return "Uploading image " + self.uploadCompletePct + " complete.";
    },
    photoComp: function () {
      if (this.photo.Path)
        return "https://www.dupaws.com/services" + this.photo.Path;
    },
    photoIdComp: function () {
      if (this.photo.SitterPhotoId) return this.photo.SitterPhotoId;
    },
    UploadPhotoTxtComp: function () {
      if (this.photo.SitterPhotoId == 0) return "Upload Fresh Background Image";
      else {
        return "Change Background Image";
      }
    },
  },
};
</script>
<style scoped>
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.background-image {
  min-height: 200px;
  max-height: 350px;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.image-preview {
  position: relative;
  border: 1px;
  width: 100%;
  max-height: 360px;
  border-radius: 5px;
  border-radius: 1px;
  text-align: center;
}

.my-button {
  position: relative;
  bottom: 50px;
}

.progress span {
  position: absolute;
  display: block;
  width: 100%;
  color: #3c3b3b;
}

.progress-image {
  position: absolute;

  width: 80%;
  z-index: 500;
  opacity: 0.9;

  top: 50%;
  left: 10%;
}

.my-button:hover {
  opacity: 1;
}

.img-preview {
  background-color: #f7f7f7;
  width: 200px;
  height: 113px;
}

.img-preview {
  float: left;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  border-radius: 5px;
}

.image-preview .close {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 100;
  background-color: #fff;
  padding: 6px 5px 5px;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  opacity: 0.2;
  text-align: center;
  font-size: 22px;
  line-height: 10px;
  border-radius: 50%;
}
.image-preview:hover .close {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// UploadBackgroundPhoto.vue?4e51670b